import { RouteObject } from 'react-router-dom';

import { TypedTFunction } from '../../i18n/i18n';
import { RouteHandle } from '../../router/routeHandles';

export type HeaderTitleData = { title: string; subTitle?: string; link?: { name: string; to: string } };

export const getLastMatchingTitle = (matches: RouteObject['handle'][], t: TypedTFunction): HeaderTitleData => {
  // Specify titles in routeHandles.ts
  const titles = matches.filter(match => Boolean(match.handle?.title));

  const lastMatch = titles[titles.length - 1];

  if (lastMatch?.handle) {
    const routeHandle = lastMatch?.handle as RouteHandle;

    if (routeHandle.bigHeader) {
      const headerMetaData = routeHandle.bigHeader;
      return {
        title: t(routeHandle.title),
        subTitle: t(headerMetaData.subTitle),
        link: headerMetaData.link ? { name: t(headerMetaData.link.name), to: headerMetaData.link.to } : undefined,
      };
    }

    return { title: t(routeHandle.title) };
  }

  return { title: t('common.serviceNames.payroll') };
};
